module.exports = __webpack_public_path__ + "img/logo.396f117a.png";